import {FormattedMessage, injectIntl} from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';
import bindAll from 'lodash.bindall';
import {toast} from 'react-hot-toast';
import { Box } from "@chakra-ui/layout";
// import PlayButton from '../../containers/play-button.jsx';
import './project-item.css';
import ProjectGridContext from './projectContext';
import {Input, message} from 'antd';
import {compose} from 'redux';
import {connect} from 'react-redux';

/* eslint-disable react/prefer-stateless-function */
class ProjectItemComponent extends React.PureComponent {
    constructor (props) {
        super(props);
        bindAll(this, [
            'handleDeleteProject',
            'handleRenameProject',
            'handleShowToolBar',
            'handleRestoreToolBar',
            'handleopenProject'
        ]);
        this.state = {
            // 显示操作栏
            isShowToolBar: false,
            isShowRenameInput: false,
            // 确认删除
            isConfirmDelete: false,
            projectName: props.name
        };
        this.preProjectName = React.createRef();
        this.formRef = React.createRef(null);
    }

    componentDidUpdate (prevProps, prevState) {
        // 选中发生变化 同时当前作品不是选中作品
        if (prevProps.projectId !== this.props.projectId && this.props.id !== this.props.projectId){
            this.handleRestoreToolBar();
        }

        
    }

    // 准备删除作品
    handleDeleteProject = event => {
        this.setState({isConfirmDelete: true});
    };

    // 确认删除作品
    handleConfirmDeleteProject (onDeleteCallback) {
        this.handleRestoreToolBar();
        onDeleteCallback();
    }

    // 切换显示操作栏
    handleShowToolBar = e => {
        // 切换显示操作栏
        this.setState({
            isConfirmDelete: false,
            isShowToolBar: !this.state.isShowToolBar
        });
    };

    // 修改作品名称
    handleProjectNameChange = event => {
        event.stopPropagation();
        this.setState({
            projectName: event.target.value
        });
    };

    // 还原操作栏
    handleRestoreToolBar = () => {
        this.setState({
            isShowToolBar: false,
            isConfirmDelete: false
        });
    };

    // 重名名作品
    handleRenameProject = event => {
        this.setState({
            isShowToolBar: false,
            isShowRenameInput: true
        });
        // 临时保存当前作品名称
        this.preProjectName.current = this.state.projectName;
    };
    // 打开作品
    handleopenProject() {
        this.props.handleConfirm(this.props.id)
    };
    // 保存作品名称
    handleSaveProjectName = onUpdateName => {
        const {projectName} = this.state;
        // 字符数字限制
        const countLimitCondition = projectName.trim().length > 30 || projectName.trim().length < 1;
        // 限制特殊字符
        const specialCharacterCondition = /[`~!@#$%^&*\-+=<>?:".{}|,\/;'\\[\]·~！@#￥%……&*——\-+={}|《》？：“”【】、；‘’，。、]/.test(projectName.trim());

        this.setState({
            isShowRenameInput: false
        });
        // 如果作品名称为空,作品名称包含特殊字符
        if (!projectName || countLimitCondition || specialCharacterCondition){
            this.setState({
                projectName: this.preProjectName.current
            });
            toast.error(<FormattedMessage
                id="gui.mywork.projectNameRules"
                defaultMessage="Project Name contain 1 to 30 characters"
            />);
            return;
        }
        if (this.preProjectName.current !== projectName) {
            const isRepeat = this.props.projectNamesList.some(i => i === projectName)
            console.log(isRepeat, this.props.projectNamesList)
            if (isRepeat) {
                message.error('该文件名已存在，请重新输入');
                this.setState({
                    projectName: this.preProjectName.current
                });
                return
            } else {
                if (onUpdateName)onUpdateName(projectName);
            }
        }
    };

    render () {
        const {
            isShowToolBar,
            isShowRenameInput,
            projectName,
            isConfirmDelete
        } = this.state;
        // 作品名称
        const projectNameText = (
            <div
                className={this.props.extensionId ? "featuredExtensionText featuredText" : "featuredText"}
                // className={
                //     this.props.extensionId ?
                //         classNames(
                //             styles.featuredExtensionText,
                //             styles.featuredText
                //         ) :
                //         styles.featuredText
                // }
            >
                <span className="libraryItemName">
                    {this.state.projectName}
                </span>
                <div className="libraryItemTime">{this.props.createTime}</div>
            </div>
        );

        return this.props.featured ? (
            <ProjectGridContext.Consumer>
                {({onRefresh, onUpdateName, onDelete}) => (
                    <div
                        // className={classNames(
                        //     styles.libraryItem,
                        //     styles.featuredItem,
                        //     this.props.className,

                        //     {
                        //         [styles.disabled]: this.props.disabled
                        //     },
                        //     this.props.extensionId ?
                        //         styles.libraryItemExtension :
                        //         null,
                        //     this.props.hidden ? styles.hidden : null
                        // )}
                        className={
                            this.props.disabled ? 
                            `libraryItem featuredItem disabled` :
                            this.props.extensionId && this.props.hidden ? 
                            `libraryItem featuredItem ${this.props.className} libraryItemExtension hidden` : 
                            this.props.extensionId ? 
                            `libraryItem featuredItem ${this.props.className} libraryItemExtension` : 
                            this.props.hidden ? 
                            `libraryItem featuredItem ${this.props.className} hidden` : 
                            `libraryItem featuredItem ${this.props.className}`
                        }
                        onClick={this.props.onClick}
                    >
                        <div className="featuredImageContainer">
                            {/* 遮罩层 */}
                            <div className={isShowToolBar ? "mask maskActive" : "mask"}>
                                <div className="toolBar">
                                    {/* 确认删除作品 */}
                                    {isConfirmDelete ? (
                                        <div style={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
                                            <div
                                                className="item"
                                                onClick={event => {
                                                    event.stopPropagation();
                                                    this.handleConfirmDeleteProject(onDelete);
                                                }}
                                            >
                                                <FormattedMessage
                                                    id="gui.prompt.ok"
                                                    defaultMessage="Confirm"
                                                />
                                            </div>
                                            <div
                                                className="item"
                                                onClick={event => {
                                                    event.stopPropagation();
                                                    this.setState({
                                                        isConfirmDelete: false
                                                    });
                                                }}
                                            >
                                                <FormattedMessage
                                                    id="gui.homePage.cancel"
                                                    defaultMessage="Cancel"
                                                />
                                            </div>
                                        </div>
                                    ) : (
                                        <div style={{display: 'flex', flexDirection: 'column', gap: '8px'}}>
                                            {/* 操作工具栏 */}
                                            {/* 编辑 */}
                                            <div
                                                className="item"
                                                onClick={
                                                    this.handleopenProject
                                                }
                                            >
                                                <FormattedMessage
                                                    id="gui.menuBar.edit"
                                                    defaultMessage="Edit"
                                                />
                                            </div>
                                            <div
                                                className="item"
                                                onClick={
                                                    this.handleRenameProject
                                                }
                                            >
                                                <FormattedMessage
                                                    id="gui.aiproject.createSelectModel.renameButton"
                                                    defaultMessage="Rename"
                                                />
                                            </div>
                                            <div
                                                className="itemDelelt"
                                                onClick={
                                                    this.handleDeleteProject
                                                }
                                            >
                                                <FormattedMessage
                                                    id="gui.mywork.project.delete"
                                                    defaultMessage="Delete"
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* 更多功能图标 */}
                            <div
                                className="moreIcon"
                                onClick={this.handleShowToolBar}
                            >
                                ...
                            </div>
                            <div
                                className="featuredImage"
                                style={{backgroundImage: `url('${this.props.iconURL}')`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat'}}
                            />

                            {isShowRenameInput ? (
                                <div className="renameInputContainer">
                              
                                    <Input
                                        bordered={false}
                                        autoFocus
                                        onBlur={() => {
                                            this.handleSaveProjectName(
                                                onUpdateName
                                            );
                                        }}
                                        type="text"
                                        value={projectName}
                                        onChange={this.handleProjectNameChange}
                                        className="renameInput"
                                        // placeholder={this.props.intl.formatMessage({id: 'gui.mywork.projectNameInputPlaceholder', defaultMessage: 'Project Name'})}
                                    />
                                   
                                
                                </div>
                            ) : (
                                projectNameText
                            )}

                        </div>

                        {this.props.insetIconURL ? (
                            <div
                                className="libraryItemInsetImageContainer">
                                <img
                                    className="libraryItemInsetImage"
                                    src={this.props.insetIconURL}
                                />
                            </div>
                        ) : null}


                        {this.props.bluetoothRequired ||
                        this.props.internetConnectionRequired ||
                        this.props.collaborator ?
                            (<div className="featuredExtensionMetadata">
                                <div
                                    className="featuredExtensionRequirement"
                                >
                                    {this.props.bluetoothRequired ||
                                        this.props
                                            .internetConnectionRequired ? (
                                            <div>
                                                    <div>
                                                    <FormattedMessage
                                                            defaultMessage="Requires"
                                                            description="Label for extension hardware requirements"
                                                            id="gui.extensionLibrary.requires"
                                                        />
                                                </div>
                                                </div>
                                        ) : null}
                                </div>
                                <div
                                    className="featuredExtensionCollaboration"
                                >
                                    {this.props.collaborator ? (
                                        <div>
                                            <div>
                                                <FormattedMessage
                                                    defaultMessage="Collaboration with"
                                                    description="Label for extension collaboration"
                                                    id="gui.extensionLibrary.collaboration"
                                                />
                                            </div>
                                            <div
                                                className="featuredExtensionMetadataDetail"
                                            >
                                                {this.props.collaborator}
                                            </div>
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            ) : null}
                    </div>
                )}
            </ProjectGridContext.Consumer>
        ) : (
            <Box
                className={
                    this.props.hidden ? "libraryItem hidden" : "libraryItem"
                }
                // className={classNames(styles.libraryItem, {
                //     [styles.hidden]: this.props.hidden
                // })}
                role="button"
                tabIndex="0"
                onBlur={this.props.onBlur}
                onClick={this.props.onClick}
                onFocus={this.props.onFocus}
                onKeyPress={this.props.onKeyPress}
                onMouseEnter={
                    this.props.showPlayButton ? null : this.props.onMouseEnter
                }
                onMouseLeave={
                    this.props.showPlayButton ? null : this.props.onMouseLeave
                }
            >
                {/* Layers of wrapping is to prevent layout thrashing on animation */}
                <Box className="libraryItemImageContainerWrapper">
                    <Box
                        className="libraryItemImageContainer"
                        onMouseEnter={
                            this.props.showPlayButton ?
                                this.props.onMouseEnter :
                                null
                        }
                        onMouseLeave={
                            this.props.showPlayButton ?
                                this.props.onMouseLeave :
                                null
                        }
                    >
                        <img
                            className="libraryItemImage"
                            src={this.props.iconURL}
                        />
                    </Box>
                </Box>
                <span className="libraryItemName">
                    {this.props.name}
                </span>
                {/* {this.props.showPlayButton ? (
                    <PlayButton
                        isPlaying={this.props.isPlaying}
                        onPlay={this.props.onPlay}
                        onStop={this.props.onStop}
                    />
                ) : null} */}
            </Box>
        );
    }
}

/* eslint-enable react/prefer-stateless-function */

ProjectItemComponent.propTypes = {
    bluetoothRequired: PropTypes.bool,
    collaborator: PropTypes.string,
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    disabled: PropTypes.bool,
    extensionId: PropTypes.string,
    featured: PropTypes.bool,
    hidden: PropTypes.bool,
    iconURL: PropTypes.string,
    insetIconURL: PropTypes.string,
    internetConnectionRequired: PropTypes.bool,
    isPlaying: PropTypes.bool,
    name: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    onBlur: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    onFocus: PropTypes.func.isRequired,
    onKeyPress: PropTypes.func.isRequired,
    onMouseEnter: PropTypes.func.isRequired,
    onMouseLeave: PropTypes.func.isRequired,
    onPlay: PropTypes.func.isRequired,
    onStop: PropTypes.func.isRequired,
    showPlayButton: PropTypes.bool,
    className: PropTypes.string,
    // intl: intlShape.isRequired,
    projectId: PropTypes.number, // 当前选中作品的id
    id: PropTypes.number, // 当前作品的id
    createTime: PropTypes.string, // 当前作品的创建时间
    handleConfirm: PropTypes.func.isRequired
};

ProjectItemComponent.defaultProps = {
    disabled: false,
    showPlayButton: false
};
const mapStateToProps = state => {
    return {
        projectNamesList: state.projectStore.projectNamesList
    };
};
const mapDispatchToProps = dispatch => ({
    // setProjectNamesList: (list) => dispatch(setProjectNamesList(list))
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps)
)(ProjectItemComponent);

// export default injectIntl(ProjectItemComponent);
